import { TableBody, TableCell, TableRow } from '@mui/material';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

interface ISkeletonLoadingProps {
    formLoading?: boolean;
    tableLoading?: boolean;
    FieldAmount?: number;
    width?: number | string;
    height?: number | string;
}
//We can build on this for different Loading variations
export const SkeletonLoading = (props: ISkeletonLoadingProps) => {

    if (props.formLoading) {
        return (
            <Box sx={{ width: props.width == null ? 300 : props.width}}>
                {Array.from(Array(props.FieldAmount).keys()).map((i) => (
                    <Skeleton animation="wave" key={i} height={props.height}/>
                ))}
            </Box>
        )
    }
    else if (props.tableLoading) {
        return (
                <TableBody>
                    {[1, 2, 3].map(row => (
                        <TableRow key={row}>
                            <TableCell>
                                <Skeleton width={150} />
                            </TableCell>
                            <TableCell>
                                <Skeleton width={100} />
                            </TableCell>
                            <TableCell>
                                <Skeleton width={200} />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
        )
    }
    else
        return (
            <div>SkeletonLoading</div>
        )
}

